<template>
  <div>
    <div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-11">
            <h4>Gestión de tarifas en avanza</h4>
            <p>
              Aquí podrá gestionar la información relacionada con las
              <span class="text-success">tarifas</span> de las eps que tienen
              convenio con <span class="text-success">Avanza</span>
            </p>
          </div>
        </div>
        <div class="card">
          <div class="col-md-12">
              <br> <br>
              <button class="btn btn-success btn-fill" @click="prepararNuevaTarifa()">Agregar tarifa</button>
            </div>
          <div class="row" id="mensaje-vacio">
            <center>
              <div class="col-md-12" v-if="queriedData2 == ''">
                <center>
                  <img
                    src="/static/img/ICONOS/estadisticas.svg"
                    alt="Imagen de datos vacios"
                    width="70"
                  />
                  <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
                </center>
              </div>
            </center>
          </div>

          <!-- tabla y paginacion -->
          <div
            class="row"
            style="padding: 15px"
            v-if="queriedData2 != ''"
            id="paginacion"
          >
            <div class="col-md-3">
              <el-select
                class="select-default"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          
           
          
            <div class="col-md-12" id="exportar">
              <br />
              <br />
              <download-excel
                class="btn btn-secondary btn-fill mb-2"
                :data="json_data"
                :fields="json_fields"
                worksheet="tarifas-especialidades"
                name="Tarifas avanza"
                v-if="json_data != ''"
              >
                Exportar a excel <i color="black" class="fa fa-download"></i>
              </download-excel>
              <br />
            </div>
            <div class="col-md-12" id="table">
              <br />
              <br />
              <el-table
                border
                :data="queriedData"
                class="table-responsive table-striped mt-2"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                >
                <template slot-scope="{ row }">
                  <div :class="getClass(column, row)" class="full-width">
                    <strong v-if="getClass(column, row) != ''">{{
                      formatearPesosColombianos(row[column.prop])
                    }}</strong>
                    <span v-else>{{ row[column.prop] }}</span>
                  </div>
                </template>
                </el-table-column>

                <el-table-column>
                  <template slot-scope="props">
                    <center>
                      <button
                        class="btn btn-simple btn-info btn-icon like"
                        @click="modal(props.row)"
                      >
                        <i class="ti-pencil"></i>
                      </button>
                    </center>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="col-sm-6 pagination-info">
              <br />
              <p class="category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <div class="col-sm-6">
              <p-pagination
                class="pull-right"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
              ></p-pagination>
            </div>
          </div>
          <modal name="agregar_tarifa" :scrollable="true" width="550" height="auto" :reset="true">
            <div class="modal-header" style="padding: 8px">
                <div class="row">
                  <div class="col-md-12">
                    <strong class="titulo-modal">
                      GESTIONAR LA INFORMACIÓN DE LAS TARIFAS DE EPS
                    </strong>
                    <br>
                    <span style="color:grey;">
                      Asignación y/o modifiación de las tarifas
                    </span>
                  </div>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <label for="eps">Eps:</label>
                    <select name="eps" id="eps" class="form-control" v-model="eps">
                      <option value="">seleccione la eps</option>
                      <option :value="eps.codigo" v-for="eps in arrayEps" :key="eps.codigo">
                        {{ eps.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <label for="eps">Especialidad:</label>
                    <select name="eps" id="eps" class="form-control" v-model="especialidad">
                      <option value="">seleccione la especialidad</option>
                      <option :value="especialidad.codigo" v-for="especialidad in arrayEspecialidades" :key="especialidad.codigo">
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <label for="tarifa">Tarifa:</label>
                    <input type="number" id="tarifa" class="form-control" v-model="tarifa">
                  </div>
                  <!-- <div class="col-md-12">
                    <label for="copago">Copago:</label>
                    <input type="number" name="copago" id="copago" class="form-control" v-model="copago">
                  </div> -->
                </div>
                <div class="row">
                  <br>
                  <center>
                    <button class="btn btn-secondary" @click="cerrarModal()" style="border-radius: 5px;">Cancelar</button>
                    <button class="btn btn-success btn-fill" v-if="accion=='registrar'" style="border-radius: 5px;" @click="newRate()">Guardar</button>
                    <button class="btn btn-success btn-fill" v-if="accion=='actualizar'" style="border-radius: 5px;" @click="updateRate()">Actualizar</button>
                  </center>
                </div>
              </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axiosInstance from "src/global-services/axiosInstance";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import JsonExcel from "vue-json-excel";
import crearAlerta from "../../global-services/crearAlerta";
import formatearPesosColombianos from "../../global-services/formatear-pesos";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    PPagination
  },
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },
  data: () => ({
    searchQuery: "",
    fechaInicial: "",
    fechaFinal: "",
    //modal agregar
    accion: 'registrar',
    eps: '',
    especialidad: '',
    tarifa: 0,
    copago: 0,
    arrayEspecialidades: [],
    arrayEps: [],
    idActualizar: '',

    //
    queriedData2: [],
    fechaActual: "",
    tableColumns: [
      {
        prop: "entidad", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Entidad", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 180, //ANCHO DE LA COLUMNA
      },
      {
        prop: "especialidad", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Especialidad", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      },
      {
        prop: "tarifa", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Tarifa", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 100, //ANCHO DE LA COLUMNA
      }
    ],
    json_fields: {
      "Entidad": "entidad",
      "Especialidad": "especialidad",
      "tarifa": "tarifa"
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    SedesProgramacion: [],
    sede: "Sede Principal",
    rol: "",
    tipo: "",
    usuarioSeleccionado: {
      nombreUsuario: "",
      tipoContrato: "",
      salarioFijo: "",
      pagoPorSesion: "",
      pagoPorSesionDomicilio: "",
      tipoContratoId: "",
      idUsuario: "",
    },
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
  }),
  methods: {
    formatearPesosColombianos,
    prepararNuevaTarifa: function(){
      this.$modal.show('agregar_tarifa');
      this.accion = 'registrar';
      this.copago = 0;
      this.tarifa = 0;
      this.especialidad = '';
      this.eps = '';
    },
    modal: function(tarifa){
      console.log(tarifa);
      this.idActualizar = tarifa.id;
      this.tarifa = tarifa.tarifa;
      this.especialidad = tarifa.especialidadId;
      this.eps = tarifa.epsId;
      this.copago = tarifa.copago;
      this.accion = 'actualizar';
      this.$modal.show('agregar_tarifa');
    },
    obtenerTarifas: async function() {
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get("api/informe-tarifas");

        this.queriedData2 = response.data.data;
        this.json_data = response.data.data;
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    getListEspecialidades: async function(){
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get("api/list-especialidades");

        this.arrayEspecialidades = response.data.data;
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    getListEps: async function(){
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get("api/list-eps");

        this.arrayEps = response.data.data;
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    newRate: async function(){
      try{
        this.$modal.show("carga");
        const data = { tarifa: this.tarifa, copago: this.copago, eps: this.eps, especialidad: this.especialidad }
        const response = await axiosInstance.post("api/newRate", data);
        if(response.data.status == false){
          this.$notify(crearAlerta("danger", response.data.mensaje));
          return;
        }

        this.$notify(crearAlerta("success", response.data.mensaje));
        this.$modal.hide("agregar_tarifa");
        this.obtenerTarifas();

      }catch(error){
        this.$notify(crearAlerta("danger", error.error));
      }finally{
        this.$modal.hide("carga");
      }
    },

    updateRate: async function(){
      try{
        this.$modal.show("carga");
        const data = { idActualizar: this.idActualizar, copago: this.copago, tarifa: this.tarifa }
        const response = await axiosInstance.post("api/updateRate", data);
        if(response.data.status == false){
          this.$notify(crearAlerta("danger", response.data.mensaje));
          return;
        }

        this.$notify(crearAlerta("success", response.data.mensaje));
        this.$modal.hide("agregar_tarifa");
        this.obtenerTarifas();
      }catch(error){
        this.$notify(crearAlerta("danger", error.error));
      }finally{
        this.$modal.hide("carga");
      }
    },
    getClass(column, row) {
      if (column.prop === "tarifa") {
        return "high-percentage";
      }
      return "";
    },
    cerrarModal: function(){
      this.$modal.hide("agregar_tarifa");
    }
  },
  mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de tarifas";
    this.obtenerTarifas();
    this.getListEps();
    this.getListEspecialidades();
  },
};
</script>
<style>
.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.btn {
  border-radius: 5px;
}

.high-percentage {
  background-color: #a0e2b3;
  /* color: white !important; */
}

.medium-percentage {
  background-color: #f2e3b0;
  /* color: black; */
}

.low-percentage {
  background-color: #fb817e;
  /* color: white; */
}

.full-width {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  /* padding: 15px; Si quieres mantener el padding interno */
}

.el-table__cell {
  height: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ADashboard/tarifas.vue